import { createSelector } from '@ngrx/store';

import { paymentState } from '../root';

export const paymentHasErrors = createSelector(paymentState, (payment) => payment.errors?.length > 0);
